const cartDrawer = document.querySelector('cart-drawer');

if (cartDrawer) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'open'
      ) {
        if (cartDrawer.hasAttribute('open')) {
          window.dispatchEvent(new Event('scroll'));
          setTimeout(() => {
              updateTotal();
          }, 500);
        }
      }
    });
  });

  observer.observe(cartDrawer, {
    attributes: true,
  });
}



function parseMoney(text) {
  if (!text) return 0;

  if (text.toLowerCase().includes('free')) return 0;

  let number = text.replace(/[^\d,.,-]/g, '');
  if (!number) return 0;

  if (number.includes('.') && number.includes(',')) {
    number = number.replace(/\./g, '');
    number = number.replace(',', '.'); 
  }
  else if (number.includes(',')) {
    number = number.replace(',', '.');
  }

  return parseFloat(number) || 0;
}

let lastTotal = null;

function updateTotal() {
  const totalEl = document.querySelector('.totals__subtotal-value.total-value-price');
  const subtotalEl = document.querySelector('.totals__subtotal-value');
  const extraEl = document.querySelector('.totals__subtotal-value-price');

  if (!subtotalEl || !totalEl) return;

  const subtotal = parseMoney(subtotalEl.innerText);
  const extra = parseMoney(extraEl?.innerText);

  const total = subtotal + extra;

  const totalInCents = Math.round(total * 100);

  if (totalInCents !== lastTotal) {
    lastTotal = totalInCents;

    totalEl.innerText = BSS_B2B.formatMoney(totalInCents);
    if(extra !== 0) {
        const extraInCents = Math.round(extra * 100);
        extraEl.innerText = BSS_B2B.formatMoney(extraInCents);
    }
    window.dispatchEvent(new Event('scroll'));

  }
}

const observer = new MutationObserver(updateTotal);

observer.observe(document.body, {
  childList: true,
  subtree: true,
  characterData: true
});

updateTotal();